import { useRef, useState } from 'react';
import useResizeObserver from '../../features/visual-analytics/hooks/resize-observer';
import styles from './Expander.module.scss';
import { Color } from '../../features/visual-analytics/helpers/colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface TpProps {
  collapsedMaxHeight: number;
  children: React.ReactNode;
  backgroundColor: Color;
}

const Expander = ({ collapsedMaxHeight: maxHeight, children, backgroundColor }: TpProps) => {
  const refExpandableSection = useRef<HTMLDivElement>(null);
  const [canExpand, setCanExpand] = useState<boolean>(false);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  useResizeObserver(refExpandableSection, (info: any) => {
    if (!refExpandableSection.current) return;
    const sectionHeight = refExpandableSection.current.clientHeight;
    setCanExpand(sectionHeight > maxHeight);
  });

  const style: any = {};
  if ((canExpand && !isExpanded) || !refExpandableSection.current) {
    style.maxHeight = `${maxHeight}px`;
  }

  const gradient = `linear-gradient(0deg, rgba(${backgroundColor.r},${backgroundColor.g},${backgroundColor.b},1) 0%, rgba(${backgroundColor.r},${backgroundColor.g},${backgroundColor.b},0.75) 50%, rgba(${backgroundColor.r},${backgroundColor.g},${backgroundColor.b},0) 100%)`;

  return (
    <div className={styles.wrapper} style={style}>
      <div ref={refExpandableSection}>{children}</div>
      {canExpand && !isExpanded && (
        <div
          className={styles.expanderBanner}
          style={{ background: gradient }}
          onClick={() => {
            setIsExpanded(true);
          }}
        >
          <div className={styles.expandButton}>
            <FontAwesomeIcon icon="caret-down" />
          </div>
        </div>
      )}
      {canExpand && isExpanded && (
        <div
          className={styles.collapserBanner}
          style={{ background: gradient }}
          onClick={() => {
            setIsExpanded(false);
          }}
        >
          <div className={styles.expandButton}>
            <FontAwesomeIcon icon="caret-up" />
          </div>
        </div>
      )}
    </div>
  );
};

export default Expander;
